<template>
  <div>
    <v-autocomplete class="mb-3" outlined dense :value="settings.locationId" @input="(val) => setLocation(val)"
      @click:append-outer="listLocations" item-text="name" item-value="uid" :items="locations" label="Location"
      :append-outer-icon="loading ? 'mdi-loading mdi-spin' : 'mdi-reload'" clearable></v-autocomplete>

    <mustache-template label="Channel Identifier" class="mb-3" :value="settings.channelIdentifier"
      @input="(val) => onUpdate(val, 'settings.channelIdentifier')" :suggestions="availableInputFields"
      :singleLine="true" />
    <mustache-template label="Channel Type" class="mb-3" :value="settings.channelType"
      @input="(val) => onUpdate(val, 'settings.channelType')" :suggestions="availableInputFields" :singleLine="true" />
    <mustache-template label="Subject (optional)" class="mb-3" :value="settings.subject"
      @input="(val) => onUpdate(val, 'settings.subject')" :suggestions="availableInputFields" :singleLine="true" />
    <mustache-template label="Body" class="mb-3" :value="settings.body" @input="(val) => onUpdate(val, 'settings.body')"
      :suggestions="availableInputFields" />
    <mustache-template label="Contact Name (optional)" class="mb-3" :value="settings.contactName"
      @input="(val) => onUpdate(val, 'settings.contactName')" :suggestions="availableInputFields" :singleLine="true" />
    <mustache-template label="Sender Name (optional)" class="mb-3" :value="settings.senderName"
      @input="(val) => onUpdate(val, 'settings.senderName')" :suggestions="availableInputFields" :singleLine="true" />
    <v-switch label="Set Open Inbox" class="mb-3" :input-value="settings.setOpenInbox"
      @change="() => onUpdate(!settings.setOpenInbox, 'settings.setOpenInbox')"></v-switch>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import MustacheTemplate from '@/components/mustache/mustache-template.vue';

const { mapActions: workflowActions } =
  createNamespacedHelpers('workflows/list');
const { mapGetters: workflowDetailsGetters } =
  createNamespacedHelpers('workflows/details');

export default {
  name: 'podium_send_message',
  components: {
    MustacheTemplate,
  },
  props: {
    availableInputFields: { required: true },
  },
  data() {
    return {
      locations: [],
      loading: false,
    };
  },
  created() {
    this.locations.push({
      uid: this.settings.locationId,
      name: this.settings.locationName,
    });
  },
  computed: {
    ...workflowDetailsGetters({
      selectedNode: 'SELECTED_NODE',
    }),
    settings() {
      return this.selectedNode.settings;
    },
  },
  methods: {
    ...workflowActions(['podiumAction']),
    onUpdate(value, path) {
      this.$emit('update', value, path);
    },
    setLocation(location) {
      const item = this.locations.find((item) => item.uid === location);
      this.onUpdate(item.name, 'settings.locationName');
      this.onUpdate(location, 'settings.locationId');
    },
    async listLocations() {
      this.loading = true;
      try {
        const data = {
          authenticationId: this.settings.authenticationId,
          action: 'list_locations',
        };
        const resp = await this.podiumAction(data);
        if (resp && resp.result) {
          this.locations = resp.result?.data || [];
        }
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style scoped lang="scss"></style>
